import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import '../styles/Auth.css';
import { api } from "../api"; 
import { buildApiErrorMessage } from '../utils/apiError';

const RecuperarSenha = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [email, setEmail] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [step, setStep] = useState(token ? 'reset' : 'email');
  const navigate = useNavigate();

  const handleSolicitacao = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await api.post('/api/auth/recuperar-senha', {
        email,
      });

      setSuccess('Email de recuperação enviado! Verifique sua caixa de entrada.');
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      const { message: friendlyMessage } = buildApiErrorMessage(
        err,
        'Não foi possível enviar o link de recuperação. Tente novamente em instantes.'
      );
      setError(friendlyMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (novaSenha !== confirmarSenha) {
      setError('As senhas não coincidem');
      setLoading(false);
      return;
    }

    if (novaSenha.length < 8) {
      setError('A senha deve ter no mínimo 8 caracteres');
      setLoading(false);
      return;
    }

    try {
      await api.post('/api/auth/resetar-senha', {
        token,
        nova_senha: novaSenha,
        confirmar_senha: confirmarSenha,
      });

      setSuccess('Senha resetada com sucesso! Redirecionando para login...');
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err) {
      const { message: friendlyMessage } = buildApiErrorMessage(
        err,
        'Não foi possível redefinir sua senha. Tente novamente.',
        { context: 'reset-password' }
      );
      setError(friendlyMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Recuperar Senha</h1>
          <p>Redefina sua senha de acesso</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        {step === 'email' ? (
          <form onSubmit={handleSolicitacao} className="auth-form">
            <div className="form-group">
              <label htmlFor="email">Email cadastrado</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                required
                disabled={loading}
              />
            </div>

            <p className="form-help-text">
              Digite o email cadastrado na sua conta. Enviaremos um link de recuperação.
            </p>

            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar Link de Recuperação'}
            </button>
          </form>
        ) : (
          <form onSubmit={handleReset} className="auth-form">
            <div className="form-group">
              <label htmlFor="nova_senha">Nova Senha</label>
              <div className="password-input-group">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="nova_senha"
                  value={novaSenha}
                  onChange={(e) => setNovaSenha(e.target.value)}
                  placeholder="Mínimo 8 caracteres"
                  required
                  disabled={loading}
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={loading}
                >
                  {showPassword ? '👁️' : '👁️‍🗨️'}
                </button>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="confirmar_senha">Confirmar Senha</label>
              <input
                type={showPassword ? 'text' : 'password'}
                id="confirmar_senha"
                value={confirmarSenha}
                onChange={(e) => setConfirmarSenha(e.target.value)}
                placeholder="Digite a senha novamente"
                required
                disabled={loading}
              />
            </div>

            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Resetando...' : 'Resetar Senha'}
            </button>
          </form>
        )}

        <div className="auth-links">
          <Link to="/login" className="link">
            Voltar para login
          </Link>
        </div>

        <div className="auth-footer">
          <p>© 2026 Fisicore. Todos os direitos reservados.</p>
        </div>
      </div>
    </div>
  );
};

export default RecuperarSenha;
